import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dasherDate',
})
export class DasherDatePipe extends DatePipe implements PipeTransform {
  transform(value: any, ...args: string[]): string {
    if (!value || value.toString() === '[object Object]' || value === '--') {
      return '--';
    }
    try {
      return super.transform(value, ...args);
    } catch (e) {
      console.warn('Failed to parse ' + value + " with args " + args, e);
      return '--';
    }
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/pipes/secure/dasher-date.pipe.ts